import styled from 'styled-components';
import Grid from '$components/layout/Grid';

const { Row } = Grid;

export const Styled = styled(Row)`
  text-align: center;
  margin: 60px auto 0;
`;
